module.exports = __webpack_public_path__ + "img/yxb1.fc61367e.jpg";